import { Box, Typography } from "@mui/material";
import MeetOverview from "../sections/Meet/MeetOverview";

const Wave = () => {
  return (
    <>
      <Box 
        sx={{
          padding: "64px 20px 0px 20px",
          height: '100vh',
          display: "flex",
          flexDirection: "column", 
          marginLeft:'55px',
          backgroundColor:"#f0f0f0"
        }}
      >
        <MeetOverview />
      </Box>
    </>
  );
};

export default Wave;
